import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

const draw = (delay = 0, duration = 1.8) => ({
  initial: { pathLength: 0, opacity: 0 },
  whileInView: { pathLength: 1, opacity: 1 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration, delay, ease: "easeInOut" },
});

const OvenBlueprint = () => {
  const { t } = useLanguage();

  return (
    <div className="relative border border-white/10 bg-white/[0.02] p-4 md:p-6" data-testid="oven-blueprint">
      <div className="flex justify-between font-mono text-[10px] tracking-widest text-white/40 mb-4 px-1">
        <span>{t.tech.blueprint}</span>
        <span className="text-micro">SCALE 1:4</span>
      </div>
      <svg viewBox="0 0 640 560" className="w-full h-auto" fill="none">
        {/* body */}
        <motion.rect x="90" y="110" width="380" height="330" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5" {...draw(0)} />
        {/* chamber */}
        <motion.rect x="130" y="160" width="300" height="210" stroke="rgba(255,255,255,0.25)" strokeWidth="1" {...draw(0.3)} />
        {/* door seam + handle */}
        <motion.path d="M110 110 V440" stroke="rgba(255,255,255,0.2)" strokeWidth="1" {...draw(0.4, 1)} />
        <motion.rect x="96" y="200" width="8" height="130" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" {...draw(0.5, 0.8)} />
        {/* racks */}
        <motion.path d="M130 230 H430 M130 300 H430" stroke="rgba(255,255,255,0.18)" strokeWidth="1" strokeDasharray="6 5" {...draw(0.6, 1.2)} />

        {/* magnetron */}
        <motion.rect x="215" y="60" width="130" height="50" stroke="#FF5A00" strokeWidth="1.5" className="glow-orange" {...draw(0.7)} />
        <motion.path d="M280 110 V130" stroke="#FF5A00" strokeWidth="1.5" className="glow-orange" {...draw(0.9, 0.5)} />
        {/* microwaves */}
        <motion.path d="M230 130 q12 18 0 36 q-12 18 0 36 q12 18 0 36" stroke="#FF5A00" strokeWidth="1.5" className="glow-orange" {...draw(1.0, 1.4)} />
        <motion.path d="M280 130 q12 18 0 36 q-12 18 0 36 q12 18 0 36" stroke="#FF5A00" strokeWidth="1.5" className="glow-orange" {...draw(1.1, 1.4)} />
        <motion.path d="M330 130 q12 18 0 36 q-12 18 0 36 q12 18 0 36" stroke="#FF5A00" strokeWidth="1.5" className="glow-orange" {...draw(1.2, 1.4)} />

        {/* fan */}
        <motion.circle cx="380" cy="265" r="42" stroke="#00E5FF" strokeWidth="1.5" className="glow-cyan" {...draw(0.8)} />
        <motion.circle cx="380" cy="265" r="6" stroke="#00E5FF" strokeWidth="1.5" className="glow-cyan" {...draw(1.0, 0.6)} />
        <motion.path d="M380 265 Q405 245 416 258 M380 265 Q355 285 344 272 M380 265 Q400 290 412 282 M380 265 Q360 240 348 248" stroke="#00E5FF" strokeWidth="1.2" className="glow-cyan" {...draw(1.1, 1.2)} />
        {/* airflow */}
        <motion.path d="M338 265 C 300 240, 240 240, 200 265 C 240 290, 300 290, 338 265" stroke="#00E5FF" strokeWidth="1" strokeDasharray="4 6" className="glow-cyan" {...draw(1.3, 1.6)} />

        {/* sensors */}
        <motion.circle cx="150" cy="180" r="4" stroke="#00E5FF" strokeWidth="1.5" className="glow-cyan" {...draw(1.2, 0.5)} />
        <motion.circle cx="410" cy="350" r="4" stroke="#00E5FF" strokeWidth="1.5" className="glow-cyan" {...draw(1.3, 0.5)} />
        <motion.path d="M150 184 V460 H260 M410 354 V500 H300" stroke="rgba(0,229,255,0.4)" strokeWidth="1" strokeDasharray="3 4" {...draw(1.4, 1.2)} />

        {/* control unit */}
        <motion.rect x="240" y="470" width="160" height="60" stroke="#FF5A00" strokeWidth="1.5" className="glow-orange" {...draw(1.5)} />
        <motion.path d="M255 492 H305 M255 508 H330" stroke="rgba(255,90,0,0.6)" strokeWidth="1" {...draw(1.7, 0.8)} />
        <text x="352" y="504" fill="#FF5A00" fontFamily="JetBrains Mono" fontSize="13" letterSpacing="2">{t.tech.core}</text>

        {/* callouts */}
        <motion.path d="M345 85 H470 M422 265 H470 M154 176 H60 M60 176 V70 H110" stroke="rgba(255,255,255,0.25)" strokeWidth="1" {...draw(1.6, 0.9)} />
        <text x="475" y="89" fill="rgba(255,90,0,0.9)" fontFamily="JetBrains Mono" fontSize="11" letterSpacing="1.5">{t.tech.magnetron}</text>
        <text x="475" y="269" fill="rgba(0,229,255,0.9)" fontFamily="JetBrains Mono" fontSize="11" letterSpacing="1.5">{t.tech.fan}</text>
        <text x="20" y="60" fill="rgba(0,229,255,0.9)" fontFamily="JetBrains Mono" fontSize="11" letterSpacing="1.5">{t.tech.sensor}</text>

        {/* dimension lines */}
        <motion.path d="M90 460 H470 M90 452 V468 M470 452 V468" stroke="rgba(255,255,255,0.2)" strokeWidth="1" {...draw(1.7, 0.7)} />
        <text x="245" y="456" fill="rgba(255,255,255,0.35)" fontFamily="JetBrains Mono" fontSize="10" letterSpacing="2">620 MM</text>
      </svg>
    </div>
  );
};

export default OvenBlueprint;
